package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesEnglish
import com.eladfinish.bible.contest.utils.MyStringUtils.replaceSpaceWithNoBreakSpace
import com.eladfinish.bible.contest.utils.RegexUtils
import com.eladfinish.bible.contest.utils.gematriaWord

class GetContentOfChapterUseCase(
    private val assetReader: AssetReader,
) {

    operator fun invoke(
        bookIndex: Int,
        chapter: String,
        onlyQri: Boolean = true,
    ): String {

        if (bookIndex < 0 || bookIndex >= bookNamesEnglish.size) {
            return ""
        }

        val pickedBookEng = bookNamesEnglish[bookIndex]
        val paddedNumPickedChapter = ChaptersRepository.padNumber(
            bookNameEnglish = pickedBookEng,
            chapterNum = chapter.gematriaWord(),
        )
        val filenameToLoad = ChaptersRepository.getFileFormat(
            number = bookIndex.plus(1),
            bookName = pickedBookEng,
            chapter = paddedNumPickedChapter,
        )
//        println(filenameToLoad)

//        val assetResource = SharedRes.assets.getAssetByFilePath(
//            filePath = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filenameToLoad
//        )!!
//        println(assetResource)
//        val chapterContent = assetReader.readFile(assetResource)
//        println(chapterContent)

        val chapterContent =
            assetReader.readFileShared(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filenameToLoad)
        var onlyContent = RegexUtils.getOnlyContent(chapterContent = chapterContent, onlyQri = onlyQri)
        onlyContent = onlyContent.replaceSpaceWithNoBreakSpace()
        return onlyContent
    }

}
